<template lang="pug">
.more-content.color_bg_vip_1
  .vip-recharge_container
    img.close-btn(src='@/assets/imgs/vip/ic_close.png' @click='closeMorePackage')
    .title.one-level.color_text_1.remain  余额
    .trans-record.color_bg_vip_4
      .tran-item(v-for="(record, index) in recordList" :key="`record-item_${index}`")
        .title.color_text_vip_2 {{ record.name }}
        .num.color_text_vip_0 {{ record.value }}
    .title.one-level.color_text_1.plan-title 超级会员加量包
    .plan-type
      .type.color_label_2.color_text_2(
        v-for="(type, index) in typeList" :key="index"
        :class="{active:(typeIndex === type.value )}"
        @click="selectType(type.value)"
      ) {{ type.name }}
    .plan-content(ref="planContent" :class="{'mutil-plan_content': planList.length > 3}")
      .plan-item.color_label_1(
        v-for="(plan, index) in planList"
        :key="index"
        :style="{'margin-right':(index === planList.length - 1? '0px': '14px')}"
        :class="{active:(planIndex === plan.planId)}"
        @click="selectPlan(plan, index)"
      )
        .title.color_text_vip_0 {{ plan.permissions }}
        .plan-price
          span.mark.color_text_vip_0 ¥
          span.price.color_text_vip_0 {{ plan.price }}
      .plan-expire.color_text_4(v-if="expire") 有效期至{{ expire }}（剩{{ limit }}天）
    .pay-area
    buy-vip-way(:currentPackage="currentPackage" :orderType="orderType" :useView="'vipRecharge'")
</template>
<script>
import service from '@/service/vip';
import util from '@/util/index';
import buyVipWay from '@/components/buyVipWay.vue';

export default {
  name: 'vipRecharge',
  components: {
    buyVipWay,
  },
  data() {
    return {
      orderType: 1, // 1为加量包套餐
      recordList: [
        {
          name: '文档翻译字符数',
          value: 0,
        },
        {
          name: '音频翻译时长',
          value: 0,
        },
        {
          name: '同传翻译时长',
          value: 0,
        },
      ],
      typeList: [
        {
          name: '文档翻译',
          value: 1,
        },
        {
          name: '音频翻译',
          value: 2,
        },
        {
          name: '同传翻译',
          value: 4,
        },
      ],
      planList: [],
      typeIndex: 1,
      planIndex: '',
      expire: '', // 过期时间
      limit: '', // 剩余天数
      currentPackage: {},
      platForm: '',
      vendor: '',
      src: '',
    };
  },
  watch: {
    '$store.state.user.account': {
      handler() {
        this.getPlans(this.typeIndex);
      },
      deep: true,
    },
  },
  mounted() {
    //  src: isPc ? 'deskdict.doctrans' : 'macdict.doctrans',
    this.src = 'web';
    this.getPlans(this.typeIndex);
    this.getDetailInfo();
  },
  methods: {
    closeMorePackage() {
      this.$emit('closeMorePackage');
    },
    // 更改类型
    selectType(type) {
      this.typeIndex = type;
      this.getPlans(type);
    },
    // 更改套餐
    selectPlan(planInfo, i) {
      this.planIndex = planInfo.planId;
      if (planInfo.expire) {
        this.expire = util.dateFormat('yyyy.MM.dd', new Date(planInfo.expire));
        this.limit = Math.ceil(planInfo.timeLeft / (1 * 24 * 60 * 60 * 1000));
      } else {
        this.expire = '';
      }
      this.currentPackage = planInfo;
      if (i >= 3) {
        this.$refs.planContent.scrollTo({
          left: 286,
          behavior: 'smooth',
        });
      // 点击最左边的套餐（约束从第2个起）向左滑动
      } else if (i <= 2) {
        this.$refs.planContent.scrollTo({
          left: 0,
          behavior: 'smooth',
        });
      }
    },
    // 获取加量包套餐列表
    getPlans(type) {
      const params = {
        increaseType: type,
        imei: '1',
        keyfrom: 'dictweb',
        apiversion: '1.0',
        product: 'webdict',
        platform: 'webdict',
      };
      service.getPlans(params).then((res) => {
        this.planList = res.data.planList;
        const firstPlan = this.planList[0];
        this.selectPlan(firstPlan);
      });
    },
    // 获取文档翻译字符数
    getDetailInfo() {
      const params = {
        src: this.src,
      };
      service.getDetailInfo(params).then((res) => {
        this.recordList[0].value = res.data.userAvailCount;
      });
      // 音频翻译余额
      const { signData, mysticTime } = util.getAudioSign();
      service.getAudioInfo(signData, mysticTime).then((res) => {
        this.recordList[1].value = util.secondToformat(res.relatedObject.audioTransRemainTime);
      });
      // 获取同传剩余
      service.getSyncInfo().then((res) => {
        this.recordList[2].value = util.secondToformat(res.data.remainTime);
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.more-content
  position fixed
  top 50%
  transform translate(-50%,-50%)
  left 50%
  z-index 99
  border-radius 10px
  height 600px
.one-level:before
  content ''
  display inline-block
  width 19px
  height 12px
  position absolute
  top -2px
  right -5px
  background url(./../assets/imgs/vip/light/title_bg.png) 0 0 / 100% 100% no-repeat
  z-index -10
.vip-recharge_container
  background url(./../assets/imgs/vip/light/bg_light.png) 0 0 / 100% 100% no-repeat
  background-size 100% auto
  box-sizing border-box
  padding 40px 32px 0 32px
  border-radius 10px
  position relative
  .close-btn
    position absolute
    right 25px
    top 7px
    width 16px
    height 16px
    cursor pointer
  .title
    font-weight 500
    font-size 16px
    line-height 19px
    display inline-block
  .remain
    padding 6px 0 5px 0
  .one-level
    position relative
  .trans-record
    height 82px
    border-radius 12px
    margin-top 8px
    display flex
    justify-content space-around
    align-items center
    margin-bottom 34px
    font-family "Gilroy"
    .tran-item
      width 198px
      text-align center
      border-right 1px solid #FFFFFF
      .title
        font-size 14px
      .num
        margin-top 3px
        font-weight 600
        font-size 18px
        line-height 21px
        font-family: 'Gilroy-SemiBold'
      &:last-child
        border-right none
  .plan-type
    display flex
    margin-top 14px
    .type
      width 68px
      height 28px
      font-weight 500
      font-size 12px
      line-height 28px
      text-align center
      border-radius 6px
      cursor pointer
      &:nth-child(2)
        margin 0 8px
    .active
      background #FFEFE0
      color #8F6339
  .plan-content
    margin-top 14px
    position relative
    white-space nowrap
    overflow-x scroll
    overflow-y hidden
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
    overflow: -moz-scrollbars-none; /* Firefox */
    &::-webkit-scrollbar
      display none
    .plan-item
      width 230px
      height 98px
      border-radius 8px
      text-align center
      box-sizing border-box
      padding 21px 0 19px 0
      display inline-block
      cursor pointer
      &:last-child
        margin-right 0
      .title
        font-size 14px
        line-height 17px
      .plan-price
        margin-top 5px
        .price
          font-family 'Gilroy-SemiBold'
          margin-left 3px
          font-weight 600
          font-size 26px
          line-height 36px
        .mark
          font-weight 700
          font-size 14px
          line-height 16px
    .active
      background rgba(252, 206, 162, 0.15)
      border 1.5px solid #FCCEA2
  .mutil-plan_content
    width 718px
    .plan-item
      width 21%
      margin-right 13px
      &:nth-last-child(2)
        margin-right 28px
  .plan-expire
    height 14px
    font-size 12px
    line-height 14px
    margin-top 12px
  .pay-area
    margin-top 32px
    /deep/ .buyVipWayPc .title
      margin 0 0 14px 0
</style>
